
import {
  INIT_COUPON_INFO,
  REQUEST_COUPON_START,
  REQUEST_COUPON_SUCCESS,
  REQUEST_COUPON_FAIL,

  REQUEST_COUPON_HISTORY_START,
  REQUEST_COUPON_HISTORY_SUCCESS,
  REQUEST_COUPON_HISTORY_FAIL,

  REQUEST_COUPON_DETAIL_START,
  REQUEST_COUPON_DETAIL_SUCCESS,
  REQUEST_COUPON_DETAIL_FAIL,

  IMPORT_MASTER_COUPON_START,
  IMPORT_MASTER_COUPON_SUCCESS,
  IMPORT_MASTER_COUPON_FAIL,

} from '../actions/coupons';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {

    case REQUEST_COUPON_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_COUPON_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_COUPON_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_COUPON_HISTORY_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_COUPON_HISTORY_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_COUPON_HISTORY_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_COUPON_DETAIL_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_COUPON_DETAIL_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_COUPON_DETAIL_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case IMPORT_MASTER_COUPON_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case IMPORT_MASTER_COUPON_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case IMPORT_MASTER_COUPON_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case INIT_COUPON_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
